export const routeConstant = {
  login: "login",
  signup: "signup",
  resetPassword: "reset-password",
  forgotPassword: "forgot-password",
  comingSoon: "coming-soon",
  kyc: "kyc",
  pre_auth_kyc: "/pre-auth/kyc",
  home: "home",
  aboutUs: "about-us",
  project: "project",
  whatToDo: "what-to-do",
  press: "press",
  jobs: "jobs",
  landingpage: "landing-page",
  contactUs: "contact-us-page",
  twoFA: "2FA",
  authOptions: "auth-options",

  pre_auth: "pre-auth",
  post_auth: "post-auth",
  popular_crypto_post_auth: "popular-crypto",
  explore_crypto_post_auth: "explore-crypto",
  open_order: "open-order",
  order_history: "order-history",
  trade_history: "trade-history",
  trendind_coins_post_auth: "trending-coins-token",
  featured_token_post_auth: "featured-token",
  trade_order: "order-trade",

  // dashboard module routes
  dashboard: "dashboard",
  dashboard_post_auth: "/post-auth/dashboard",
  dashboard_popular_crypto_post_auth: "/post-auth/dashboard/popular-crypto",
  dashboard_watchlist_post_auth_token:
    "/post-auth/dashboard/watchlist/token/details",
  dashboard_popular_crypto_post_auth_token:
    "/post-auth/dashboard/popular-crypto/token/details",
  dashboard_trending_coin_token_post_auth_token:
    "/post-auth/dashboard/trending-coins-token/token/details",
  dashboard_post_auth_token_view_all: "/post-auth/dashboard/token/view-all",
  dashboard_featured_token_post_auth_token:
    "/post-auth/dashboard/featured-token/token/details",

  // settings module routes
  settings: "settings",
  profile: "profile",
  security: "security",
  payment: "payment",
  preference: "preference",
  activity: "activity",
  device: "device",
  settings_profile: "/post-auth/settings/profile",
  setttings_security: "/post-auth/settings/security",
  settings_payments: "/post-auth/settings/payment",
  settings_preference: "/post-auth/settings/preference",
  settings_activity: "/post-auth/settings/activity",
  settings_device: "/post-auth/settings/device",

  // trade module routes
  trade: "trade",
  post_auth_trade_home: "/post-auth/trade/home",
  open_order_post_auth: "/post-auth/trade/open-order",
  order_history_post_auth: "/post-auth/trade/order-history",
  tread_history_post_auth: "/post-auth/trade/trade-history",
  post_auth_trade_order_trade: "/post-auth/trade/order-trade",

  // explore routes
  explore: "explore",
  post_auth_explore_home: "/post-auth/explore/home",
  post_auth_explore_watchlist: "/post-auth/explore/watchlist",
  post_auth_explore_token: "/post-auth/explore/token/details",
  post_auth_explore_explore_crypto: "/post-auth/explore/explore-crypto",
  post_auth_explore_explore_crypto_token:
    "/post-auth/explore/explore-crypto/token/details",
  post_auth_explore_watchlist_token:
    "/post-auth/explore/watchlist/token/details",
  post_auth_explore_trending_coin_token:
    "/post-auth/explore/trending-coins-token/token/details",
  post_auth_explore_token_view_all: "/post-auth/explore/token/view-all",

  // wallet module routes
  wallet: "wallet",
  wallet_post_auth: "/post-auth/wallet",

  // watchlist module routes
  watchlist: "watchlist",
  post_auth_watchlist: "/post-auth/dashboard/watchlist",
  post_auth_watchlist_token: "/post-auth/watchlist/token",

  // token module routes
  token: "token",
  details: "details",
  view_all: "view-all",
};
